import { Injectable } from '@angular/core';
import { Profile } from '../models/interfaces/profile.interface';
import { HttpHeaders } from '@angular/common/http';
import { ToolsService } from './tools.service';

@Injectable({ providedIn: 'root' })
export class ProfileService {

  userProfile: Profile | undefined = undefined;
  userProfileToken: string | null = null;
  httpOptionsBearer: any = {};
  resourceNotFound: boolean = false;

  constructor(public toolsService: ToolsService) {}

  setHeaderToken() {
    this.httpOptionsBearer = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,POST,PATCH,DELETE,PUT,OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Content-Type, Accept',
        'Content-Type': 'application/json',
        'TransactionID': this.toolsService.generateUuid()
      })
    }

    // Necessario se faccio il REFRESH della pagina senza passare per l'AUTH
    this.userProfileToken = !!this.userProfileToken ? this.userProfileToken : localStorage.getItem('userProfileToken');
    if (!!this.userProfileToken) {
      this.httpOptionsBearer.headers['Authorization'] = 'Bearer ' + this.userProfileToken;
    }
  }
}
